! function() {
  function a() {
    y = 0 == y ? Object.keys(h)[0] : y;
    var a = {};
    return $.each(document.location.search.substr(1).split("&"), function(i, t) {
      var e = t.split("=");
      try {
        a[e[0].toString()] = e[1].toString()
      } catch (n) {}
    }), (isNaN(a.variant) ? $('[name="id"]').val() : a.variant ? a.variant : $("select option[value='" + y + "']").parent().val()) || y
  }

  function i() {
    return document.location.search.indexOf("variant=") >= 0
  }

  function t(t) {
    t || (t = a());
    var e = f.hasOwnProperty(t) ? f[t] : f[y];
    return e && 0 != e.length ? s && !i() ? g : ("at_start" == b ? e = f.g.concat(e) : "at_end" == b && (e = e.concat(f.g)), e) : g
  }

  function e(a, i) {
    return JSON.stringify(a) === JSON.stringify(i)
  }
  var n = !1,
      r = 0,
      l = "Icon",
      d = !1,
      o = !1,
      s = !1,
      u = "include";
  window.variant_images = {};
  var c = 0,
      m = {};
  if ("/" == window.location.pathname && ["Startup", "Flow", "Debut", "Success theme", "Supply V2", "Launch"].indexOf(l) >= 0) d = !0, o = !0;
  else if (window.location.href.toLowerCase().indexOf("/products/") >= 0) d = !0;
  else if (n) var p = setInterval(function() {
    if (window.$ && window.jQuery) return clearInterval(p), void $(document).ajaxComplete(function(a, i, t) {
      t.url.indexOf("/products/") >= 0 && $(".qvimages").hide()
    })
  }, 10);
  if (d) {
    if (o) {
      var v = "";
      "Startup" == l ? v = $('[data-section-type="featured-product"] .product-title a').prop("href") : "Flow" == l ? v = $("#product-box .product-details--form-wrapper a").prop("href") : "Debut" == l || "Success theme" == l || ("Supply V2" == l ? v = $('[data-section-type="product-template"] a.full-details').prop("href") : "Launch" == l && (v = $(".home-featured-product .product-title a").prop("href"))), v = v.replace(/\/$/, "").split("?")[0].split("#")[0]
    } else v = window.location.pathname.replace(/\/$/, "");
    if ("undefined" == typeof window.via_product_handle || window.via_product_handle != v) {
      window.via_product_handle = v;
      var f = {},
          h = {};
      f.g = [];
      var g = [],
          y = 0,
          b = "at_end",
          w = new XMLHttpRequest;
      w.open("GET", v + ".js", !0), w.send(), w.onreadystatechange = function() {
        var a = 4,
            i = 200;
        if (w.readyState === a && w.status === i) {
          var t = JSON.parse(w.responseText);
          for (var e in t.variants)
            if (!y && t.variants[e].available) return y = t.variants[e].id, !1
              }
      };
      var _ = new XMLHttpRequest;
      _.open("GET", v + ".json", !0), _.send(), _.onreadystatechange = function() {
        var i = 4,
            n = 200;
        if (_.readyState === i && _.status === n) {
          var l = JSON.parse(_.responseText).product;
          g = l.images;
          var d = !0,
              o = [],
              s = [],
              p = [];
          if ("include" == u && -1 == l.tags.toLowerCase().indexOf("via_enabled")) return !1;
          if ("exclude" == u && l.tags.toLowerCase().indexOf("via_disabled") >= 0) return !1;
          l.variants.forEach(function(a) {
            a.image_id && (p[a.image_id] || (p[a.image_id] = []), p[a.image_id].push(a.id)), f[a.id] = [], h[a.id] = a
          }), l.images.forEach(function(a, i) {
            var t = p[a.id];
            (t && (a.variant_ids.push.apply(a.variant_ids, t), a.variant_ids = a.variant_ids.filter(function(a, i, t) {
              return t.indexOf(a) == i
            })), d && 0 == a.variant_ids.length) ? r > 0 && i < r || f.g.push(a): (d = !1, (o = a.variant_ids.length ? a.variant_ids : o).forEach(function(i) {
              f[i].push(a)
            }), s.push(a))
          });
          var v = setInterval(function() {
            window.$ && window.jQuery && (clearInterval(v), $(document).ready(function() {
              function i(a) {
                if (variant_images = t(a), !e(m, variant_images)) {
                  
                  m = variant_images, $("#thumbnail-gallery .thumbnail-slider").bxSlider("destroy"), $(".bx-controls.bx-has-pager.bx-has-controls-direction").remove();
                  var i = "";
                  var count = 0;
                  //$('.slider-dots').html();
                 
                  $.each(variant_images, function(a, t) {
                    count++;
                    $('.slider-dots').append("<a href='javascript:void(0);' data-image-id='" + t.id + "' class='slider-dot'></a>");
                    i += $("#multi-variant-info div[data-image-id='" + t.id + "']").clone().wrap("<div></div>").parent().html(), 
                      $("#multi-variant-mobile li[data-image-id='" + t.id + "']").clone().wrap("<div></div>").parent().html()
                  }),
                    i += $(".hidden_media").html(),
                    $("#thumbnail-gallery").html("<div class='thumbnail-slider'></div>"), 
                    $("#thumbnail-gallery .thumbnail-slider").html(i), 
                    $("#thumbnail-gallery .thumbnail-slider").bxSlider({
                    minSlides: 5,
                    maxSlides: 5,
                    mode: 'vertical',
                    slideMargin: 10,
                    slideWidth: 200,
                    infiniteLoop: !1,
                    pager: !1,
                    prevText: "",
                    nextText: "",
                    hideControlOnEnd: !0
                  }), 
                  $(".clicker-thumb, #thumbnail-gallery div.slide a, #thumbnail-gallery .product-thumbnail").off("click").on("click", function(a) {

                     // itg js
                    
                        var clickedThumb = $(this); 
                        var mainContainer = $("#product-main-image");
                        
                        if (clickedThumb.parent().hasClass("product-image")) {
                            var newImageSrc = clickedThumb.attr("href");
                            console.log(newImageSrc);
                            mainContainer.html('<img src="' + newImageSrc + '" alt="Product Image">');
                              $('#product-main-image').zoom();
                              mainContainer.data("zoom-initialized", true);
                        } else if (clickedThumb.parent().hasClass("product-single__video")) {
                            var videoSrc = clickedThumb.attr("href");
                            var videoTag = '<video autoplay loop><source src="' + videoSrc + '" type="video/mp4"></video>';
                            mainContainer.html(videoTag);
                        }
                              
                    if (a.stopPropagation(), a.preventDefault(), 0 == $(".product-thumbnail").length) {
                      var i = $(this).attr("href");
                      $("#product-main-image img").attr({
                        src: i
                      }), $(".main-product-image img").attr({
                        src: i
                      })
                    } else {
                      var t = $(this).closest("[data-image-id]").data("image-id"),
                          e = $(".product-main-image").filter("[data-image-id=" + t + "]");
                      if (!e.length) return !1;
                      $("#thumbnail-gallery .product-thumbnail").removeClass("selected").filter("[data-image-id=" + t + "]").addClass("selected"), $(".product-main-image").removeClass("selected").hide().filter(e).addClass("selected").show()
                    }
                    return !1
                  }), $("#thumbnail-gallery .slide:nth-child(1) a").trigger("click"), $("#thumbnail-gallery .product-thumbnail:nth-child(1)").trigger("click")
                }



              }
              $("body").append("<div id='multi-variant-mobile' style='display:none'></div>"), $("#multi-variant-mobile").html($(".mobile-gallery .slides").html()), $("#thumbnail-gallery div.slide").each(function(a, i) {
                $(i).attr("data-image-id", g[a].id)
              }), $("body").append("<div id='multi-variant-info' style='display:none'></div>"), $("#multi-variant-info").html($("#thumbnail-gallery").html()), $("#multi-variant-info img.lazyloading").removeClass("lazyloading").addClass("lazyload"), i();
              var n = 0;
              $("body").on("change click", "select, .single-option-selector", function() {
                console.log('dsf');
                setTimeout(function() {
                  c = a(), n != c && (i(c), n = c)
                }, 100)
              })
            }))
          }, 10)
          }
      }
    }
  }

}();
// $(document).ready(function(){
//   $('.product-mobile-slider').slick({
//     dots:true,
//   });
// });

$(document).ready(function(){
$('.product-mobile-slider-img').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  dots:true
});

  // $('.thumbnail-slider').slick({
  //   slidesToShow: 5,
  //   slidesToScroll: 1,
  //   infinite: false,
  //   dots: false,
  //   vertical: true,
  //   focusOnSelect: true, 
  // });
  
  $('.product-mobile-slider-img').on('afterChange', function(event, slick, currentSlide) {
  var video = $(slick.$slides[currentSlide]).find('video')[0];
  if (video) {
    video.play();
  }
});

});